var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BButton',{attrs:{"no-caret":"","variant":"outline-secondary","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{staticClass:"material-icons-outlined"},[_vm._v(" remove ")])])}
var staticRenderFns = []

export { render, staticRenderFns }